var ActionBuilder = /** @class */ (function () {
    function ActionBuilder() {
        this._async = false;
    }
    ActionBuilder.prototype.params = function (metaArgs) {
        this._metaArgs = metaArgs;
        return this;
    };
    ActionBuilder.prototype.action = function (func) {
        this._func = func;
        return this;
    };
    ActionBuilder.prototype.async = function (async) {
        this._async = async;
        return this;
    };
    ActionBuilder.prototype.name = function (name) {
        this._name = name;
        return this;
    };
    ActionBuilder.prototype.build = function () {
        return new ActionBuilder.layoutActionImpl(this._name, this._metaArgs, this._func, this._async);
    };
    /* tslint:disable:max-classes-per-file*/
    ActionBuilder.layoutActionImpl = /** @class */ (function () {
        function class_1(name, metaArgs, func, async) {
            this.isAsync = false;
            this.name = name;
            this.metaArgs = metaArgs;
            this.func = func;
            this.isAsync = async;
        }
        return class_1;
    }());
    return ActionBuilder;
}());
export { ActionBuilder };
//# sourceMappingURL=layout-action.builder.js.map